import { Button, ConfigProvider, Modal, Progress, Table, Upload } from 'antd';
import './index.scss';
import { CloseSvg } from 'utils/svgs';
import {
	DownloadOutlined,
	LoadingOutlined,
	UploadOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import { getApiCSV, postApi } from 'redux/apis';
import { parseToNumber, toastText } from 'utils/utils';
import csvToJson from 'csvtojson';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

const isEmployeeColumn = (columnName: any) => {
	const normalizedName = String(columnName || '')
		.toLowerCase()
		.trim();
	const employeeKeywords = ['employee', 'emp', 'name', 'employee name'];
	return employeeKeywords.some((keyword) => normalizedName.includes(keyword));
};

export const ImportEmployeeCostCsvModal = (props: any) => {
	const navigate = useNavigate();

	const [jsonResult, setJsonResult] = useState<any[]>([]);

	const [tableHeaders, setTableHeader] = useState<any>([]);

	const [loading, setLoading] = useState(false);

	const [loadingSaveEmployeeCost, setLoadingSaveEmployeeCost] = useState(false);

	const exportEmployeeCostFile = async () => {
		const payPeriodId = localStorage.getItem('payPeriod');
		const companyId = localStorage.getItem('companyId');
		const companyName = localStorage.getItem('companyName');

		try {
			setLoading(true);
			const response: any = await getApiCSV('/employee-cost/sample-export', {
				payPeriodId,
				companyId,
			});
			// const url = window.URL.createObjectURL(
			// 	new Blob([response.data], {
			// 		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			// 	})
			// );

			const bom = new Uint8Array([0xef, 0xbb, 0xbf]); // UTF-8 BOM
			const blob = new Blob([bom, response.data], {
				type: 'text/csv;charset=utf-8;',
			});

			const url = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `Employee_Cost_${companyName}.csv`);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (error: any) {
			console.log(error);
			if (error?.response?.data?.error?.status == 401) {
				navigate('/login');
				window.location.reload();
			} else {
				toastText('Error while exporting employee cost csv', 'error');
			}
		}

		setLoading(false);
	};

	const handleFileUpload = async (info: any) => {
		if (info.file) {
			const reader = new FileReader();
			reader.onload = async (e: any) => {
				// const csvData = e.target.result;
				const arrayBuffer = e.target.result;
				const decoder = new TextDecoder('utf-8');
				const csvData = decoder.decode(arrayBuffer);
				const headers = csvData.split('\n')[0].split(',');

				const jsonData = await csvToJson({
					headers, // Don't use first row as headers
					includeColumns: /./, // Include all columns
				}).fromString(csvData);

				const _jsonData: any[] = [];

				jsonData.forEach((data) => {
					const obj: any = {};
					// Object.keys(data).forEach((key) => {
					// 	obj[key.trim()] = data[key];
					// });
					Object.keys(data).forEach((key) => {
						const trimmedKey = key.trim();
						const rawValue = data[key];

						// For Employee column, keep as string
						if (
							trimmedKey.toLowerCase() === 'employee' ||
							trimmedKey.toLowerCase() === 'emp' ||
							trimmedKey.toLowerCase() === 'name'
						) {
							obj[trimmedKey] = String(rawValue || '').trim();
						} else {
							// For all other columns, convert to number
							obj[trimmedKey] = parseToNumber(rawValue);
						}
					});
					_jsonData.push(obj);
				});

				const data = _jsonData[0];

				// setTableHeader(
				// 	Object.keys(data).map((e) => {
				// 		return {
				// 			title: e,
				// 			dataIndex: e,
				// 			key: e,
				// 			width: 200,
				// 		};
				// 	})
				// );
				setTableHeader(
					Object.keys(data).map((event) => {
						return {
							title: event,
							dataIndex: event,
							key: event,
							width: 200,
							render: (text: any) => {
								// const num = Number(text);
								// if (!isNaN(num) && num < 0) {
								// 	return (
								// 		<span style={{ color: 'red' }}>({Math.abs(num)})</span>
								// 	);
								// }
								// return text;
								if (isEmployeeColumn(event)) {
									return String(text || '').trim();
								}
								const numValue = parseToNumber(text);
								// Display negative numbers in red with parentheses
								if (numValue < 0) {
									return (
										<span style={{ color: 'red' }}>
											({Math.abs(numValue).toLocaleString()})
										</span>
									);
								}

								// Display positive numbers with proper formatting
								return numValue.toLocaleString();
							},
						};
					})
				);

				setJsonResult(_jsonData);
			};
			reader.readAsArrayBuffer(info.file);
		}
	};

	// const handleSaveEmployeeCost = async () => {
	// 	setLoadingSaveEmployeeCost(true);
	// 	try {
	// 		const res = await postApi('/employee-cost/import', {
	// 			payPeriodId: localStorage.getItem('payPeriod'),
	// 			companyId: localStorage.getItem('companyId'),
	// 			employeeCostData: jsonResult,
	// 		});

	// 		if (res.data.data.success) {
	// 			toastText('Employee cost updated successfully', 'success');
	// 			props.onClose && props.onClose();
	// 		}
	// 	} catch (error: any) {
	// 		console.log(error);
	// 		toastText('Error while updating employee cost', 'error');
	// 	}
	// 	setLoadingSaveEmployeeCost(false);
	// };
	const [uploadProgress, setUploadProgress] = useState(0);
	const [uploadedEmployeeCount, setUploadedEmployeeCount] = useState(0);
	const [totalEmployeeCount, setTotalEmployeeCount] = useState(0);
	// const handleSaveEmployeeCost = async () => {
	// 	setLoadingSaveEmployeeCost(true);
	// 	setUploadProgress(0); // Reset progress at start

	// 	const chunkArray = (arr: any[], size: number) => {
	// 		return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
	// 			arr.slice(i * size, i * size + size)
	// 		);
	// 	};

	// 	try {
	// 		const payPeriodId = localStorage.getItem('payPeriod');
	// 		const companyId = localStorage.getItem('companyId');

	// 		const chunks = chunkArray(jsonResult, 10);
	// 		const totalChunks = chunks.length;
	// 		setUploadedEmployeeCount(0); // reset
	// 		setTotalEmployeeCount(jsonResult.length); // total employees
	// 		const failedChunks: number[] = [];

	// 		for (let i = 0; i < chunks.length; i++) {
	// 			try {
	// 				const res = await postApi('/employee-cost/import', {
	// 					payPeriodId,
	// 					companyId,
	// 					employeeCostData: chunks[i],
	// 				});
	// 				setUploadedEmployeeCount((prev) => prev + chunks[i].length);

	// 				if (!res.data?.data?.success) {
	// 					failedChunks.push(i + 1); // Track failed chunk number (1-based)
	// 				}
	// 			} catch (err) {
	// 				console.log(`Chunk ${i + 1} failed`, err);
	// 				failedChunks.push(i + 1);
	// 			}

	// 			// ✅ Update progress
	// 			const progress = Math.round(((i + 1) / totalChunks) * 100);
	// 			setUploadProgress(progress);
	// 		}

	// 		if (failedChunks.length === 0) {
	// 			toastText('Employee cost updated successfully', 'success');
	// 			props.onClose && props.onClose();
	// 		} else {
	// 			const failedStr = failedChunks.join(', ');
	// 			toastText(`Error updating chunk(s): ${failedStr}`, 'error');
	// 		}
	// 	} catch (error: any) {
	// 		console.log('Unexpected error:', error);
	// 		toastText('Error while updating employee cost', 'error');
	// 	}

	// 	setLoadingSaveEmployeeCost(false);
	// };

	const handleSaveEmployeeCost = async () => {
		setLoadingSaveEmployeeCost(true);
		setUploadProgress(0);

		const chunkArray = (arr: any[], size: number) => {
			return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
				arr.slice(i * size, i * size + size)
			);
		};

		// try {
		// 	const payPeriodId = localStorage.getItem('payPeriod');
		// 	const companyId = localStorage.getItem('companyId');

		// 	if (!payPeriodId || !companyId) {
		// 		toastText('Missing Pay Period or Company ID', 'error');
		// 		setLoadingSaveEmployeeCost(false);
		// 		return;
		// 	}

		// 	const allEmployeeNames = jsonResult.map((e) => e['Employee']);

		// 	// 🔹 Step 1: Fetch meta
		// 	const metaRes: any = await postApi('/employee-cost/import/import-meta', {
		// 		payPeriodId,
		// 		companyId,
		// 		allEmployeeNames,
		// 	});

		// 	if (!(metaRes?.data.statusCode == 200)) {
		// 		toastText('Failed to fetch configuration or existing data.', 'error');
		// 		setLoadingSaveEmployeeCost(false);
		// 		return;
		// 	}

		// 	const {
		// 		configurationSections,
		// 		sectionWiseFieldsMapping,
		// 		sectionWiseTotalFieldName,
		// 		existingValueMapEntries,
		// 	} = metaRes.data.data;

		// 	const cachedConfig = {
		// 		configurationSections,
		// 		sectionWiseFieldsMapping,
		// 		sectionWiseTotalFieldName,
		// 		existingValueMapEntries,
		// 	};

		// 	// 🔹 Step 2: Chunk employee data
		// 	const chunks = chunkArray(jsonResult, 10);
		// 	const totalChunks = chunks.length;
		// 	setUploadedEmployeeCount(0);
		// 	setTotalEmployeeCount(jsonResult.length);
		// 	const failedChunks: number[] = [];

		// 	// 🔹 Step 3: Upload in chunks
		// 	for (let i = 0; i < chunks.length; i++) {
		// 		try {
		// 			const chunkRes: any = await postApi(
		// 				'/employee-cost/import/import-chunk',
		// 				{
		// 					payPeriodId,
		// 					companyId,
		// 					employeeCostData: chunks[i],
		// 					cachedConfig, // Send cached meta
		// 				}
		// 			);

		// 			setUploadedEmployeeCount((prev) => prev + chunks[i].length);

		// 			if (!(chunkRes?.data.statusCode == 200)) {
		// 				failedChunks.push(i + 1);
		// 			}
		// 		} catch (err) {
		// 			console.error(`Chunk ${i + 1} failed`, err);
		// 			failedChunks.push(i + 1);
		// 		}

		// 		// Progress update
		// 		const progress = Math.round(((i + 1) / totalChunks) * 100);
		// 		setUploadProgress(progress);
		// 	}

		// 	// 🔹 Step 4: Final result
		// 	if (failedChunks.length === 0) {
		// 		toastText('Employee cost updated successfully', 'success');
		// 		props.onClose && props.onClose();
		// 	} else {
		// 		toastText(
		// 			`Error updating chunk(s): ${failedChunks.join(', ')}`,
		// 			'error'
		// 		);
		// 	}
		// } catch (error) {
		// 	console.error('Unexpected error:', error);
		// 	toastText('Unexpected error while saving employee cost', 'error');
		// }

		try {
			const payPeriodId = localStorage.getItem('payPeriod');
			const companyId = localStorage.getItem('companyId');

			if (!payPeriodId || !companyId) {
				toastText('Missing Pay Period or Company ID', 'error');
				setLoadingSaveEmployeeCost(false);
				return;
			}

			const processedJsonResult = jsonResult.map((row) => {
				const processedRow: any = {};
				Object.keys(row).forEach((key) => {
					// Keep employee name as string
					if (
						key.toLowerCase() === 'employee' ||
						key.toLowerCase() === 'emp' ||
						key.toLowerCase() === 'name'
					) {
						processedRow[key] = String(row[key] || '').trim();
					} else {
						// Convert all other fields to numbers
						processedRow[key] = parseToNumber(row[key]);
					}
				});
				return processedRow;
			});

			// const chunks = chunkArray(jsonResult, 100); // split into chunks of 100
			const chunks = chunkArray(processedJsonResult, 100); // split into chunks of 100
			const failedChunks: number[] = [];

			setUploadedEmployeeCount(0);
			setTotalEmployeeCount(jsonResult.length);

			for (let i = 0; i < chunks.length; i++) {
				try {
					const chunkRes: any = await postApi(
						'/employee-cost/importEmployeeCostValueCsvV2',
						{
							payPeriodId,
							companyId,
							employeeCostData: chunks[i],
						}
					);

					if (!chunkRes.data.data.success) {
						failedChunks.push(i + 1);
					} else {
						setUploadedEmployeeCount((prev) => prev + chunks[i].length);
					}
				} catch (error) {
					console.error(`Chunk ${i + 1} failed:`, error);
					failedChunks.push(i + 1);
				}

				// Optionally update progress UI
				const progress = Math.round(((i + 1) / chunks.length) * 100);
				setUploadProgress(progress);
			}

			if (failedChunks.length === 0) {
				toastText('Employee cost imported successfully', 'success');
				props.onClose && props.onClose();
			} else {
				toastText(
					`Failed to import chunk(s): ${failedChunks.join(', ')}`,
					'error'
				);
			}
		} catch (error) {
			console.error('Unexpected error:', error);
			toastText('Unexpected error while importing employee cost', 'error');
		} finally {
			setLoadingSaveEmployeeCost(false);
		}

		setLoadingSaveEmployeeCost(false);
	};

	return (
		<>
			{' '}
			<Modal
				open={props.open}
				closable={false}
				footer={false}
				className="employee-cost-import-modal"
				width={1500}
			>
				<ConfigProvider
					theme={{
						components: {
							Button: {
								colorPrimaryHover: 'black',
								colorPrimary: 'black',
								borderRadius: 1000,
								controlHeight: 50,
								fontSize: 16,
								colorBorder: 'black',
							},
						},
					}}
				>
					<div className="employee-cost-import-modal__title">
						<div className="employee-cost-import-modal__title-label">
							Import Employee Cost
						</div>
						<div
							style={{ cursor: 'pointer' }}
							onClick={() => {
								props.onClose && props.onClose();
							}}
						>
							<CloseSvg />
						</div>
					</div>
					<div className="employee-cost-import-modal__container">
						<p className="employee-cost-import-modal__container--notes">
							Note: Download the CSV file below, update the values, and then
							re-upload the updated CSV file to change the employee cost values
						</p>
						<div className="employee-cost-import-modal__container--buttons">
							<Button
								onClick={() => exportEmployeeCostFile()}
								loading={loading}
								type="primary"
								style={{
									backgroundColor: '#344735',
									fontSize: '12px',
									borderRadius: '12px',
									height: '41px',
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DownloadOutlined /> Export Employee Cost CSV
							</Button>
							<Upload
								accept="text/csv"
								onChange={(e) => {
									handleFileUpload(e);
								}}
								showUploadList={false}
								beforeUpload={() => false}
							>
								<Button
									style={{
										marginLeft: '10px',
										width: '150px',
										fontSize: '12px',
										borderRadius: '12px',
										height: '41px',
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
									icon={<UploadOutlined />}
								>
									Upload
								</Button>
							</Upload>
						</div>
						{jsonResult && jsonResult.length ? (
							<>
								<div className="employee-cost-import-modal__container--table">
									<div className="employee-cost-table-wrapper">
										<Table
											scroll={{ y: '40vh' }}
											pagination={false}
											dataSource={jsonResult}
											columns={tableHeaders}
											rowKey={(data) => {
												return data['Employee'];
											}}
										/>
									</div>
								</div>
								<div className="employee-cost-import-modal__container--action-buttons">
									<Button
										onClick={() => handleSaveEmployeeCost()}
										style={{
											width: '90px',
											backgroundColor: '#344735',
											borderColor: '#344735',
											color: '#fff',
											fontSize: '12px',
											borderRadius: '12px',
											height: '41px',
										}}
									>
										{' '}
										Save
									</Button>
									<Button
										onClick={() => {
											setJsonResult([]);
											setTableHeader([]);
										}}
										style={{
											marginLeft: '10px',
											width: '90px',
											fontSize: '12px',
											borderRadius: '12px',
											height: '41px',
										}}
									>
										{' '}
										Cancel
									</Button>
								</div>
							</>
						) : null}
					</div>
				</ConfigProvider>
			</Modal>
			{loadingSaveEmployeeCost && (
				<Modal
					open={loadingSaveEmployeeCost}
					onCancel={props.onClose}
					footer={null}
					closable={false}
					centered
					maskClosable={false}
				>
					{loadingSaveEmployeeCost && (
						<>
							<Spin
								spinning={uploadProgress === 0}
								indicator={
									<LoadingOutlined
										style={{ fontSize: 16, color: '#344735' }}
										spin
									/>
								}
								tip="Uploading employee cost data..."
								className="employee-cost-upload-modal" // Add this class
							>
								<p
									style={{
										marginBottom: 10,
										display: 'flex',
										alignItems: 'center',
										gap: 8,
										fontSize: '12px',
									}}
								>
									{uploadProgress == 0 ? (
										<></>
									) : uploadProgress < 90 ? (
										`Uploading employee cost data... ${uploadedEmployeeCount} of ${totalEmployeeCount} employees.`
									) : uploadProgress < 100 ? (
										`Finalizing... ${uploadedEmployeeCount} of ${totalEmployeeCount} employees`
									) : (
										'Upload complete ✅'
									)}
								</p>

								<Progress
									percent={uploadProgress}
									status={uploadProgress === 100 ? 'success' : 'active'}
									strokeColor="#344735"
								/>
							</Spin>
						</>
					)}
				</Modal>
			)}
		</>
	);
};
